module.exports = __webpack_public_path__ + "img/icon-play.d4bef698.png";